import React from 'react';
import '../App.css';
import cfl from '../config.json';
import $ from 'jquery';
import config from '.././config.json';
import moment from 'moment';
import {
    Form, Input, Tooltip, Icon, Select,
    Button, DatePicker, InputNumber, Spin, notification
} from 'antd';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const Option = Select.Option;

class GradeStudent extends React.Component {
    formVariables = [{ AttendedDate: '' }, { CompletionDate: '' }, { Status: '' }, { Comments: '' }];

    constructor(props) {
        super(props);
        this.props.form.validateFieldsAndScroll((err, values) => {
            this.formVariables.AttendedDate = values.AttendedDate;
            this.formVariables.CompletionDate = values.CompletionDate;
            this.formVariables.Status = values.Status;
            this.formVariables.Comments = values.Comments;
        });

        this.state = {
            statusData: [],
            loading: false,
            login: true
        };

    }

    componentDidMount() {
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => {
                //Type Dropdown
                this.ajaxCall('POST', '/api/dropdown/getdropdown',
                    { "DropdownName": "Cert_CompletionCriteria", "DropdownDataColumns": ["Criteria"] }, (data) => {
                        this.setState({
                            statusData: data
                        })
                    }, () => {
                        console.log('failed to get ClassType data');
                    });
                this.formVariables.AttendedDate = moment(this.props.updateFields.AttendedDate);
                this.formVariables.CompletionDate = moment(this.props.updateFields.CompletionDate);
                this.formVariables.Comments = this.props.updateFields.Comments;


                this.ajaxCall('GET', '/api/classes/getid/' + this.props.gradingClassId,
                    {}, (data) => {//success
                        this.props.form.setFieldsValue({
                            ['AttendedDate']: moment(data.StartDate),
                            ['CompletionDate']: moment(data.EndDate),
                        });

                    }, () => {//fail
                        console.log('failed to get data');
                    });
            }); //login



    }

    /**
    * Grading student event
    */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                //Format the data to be recieved by the server
                if (typeof this.props.multipleData !== 'undefined' && this.props.multipleData.length > 1 && this.props.updateFields.Id == null) {
                    var formObj = {
                        AttendedDate: values.AttendedDate.format("YYYY-MM-DD HH:mm:ss"),
                        CompletionDate: values.CompletionDate.format("YYYY-MM-DD HH:mm:ss"),
                        CompletionCriteriaId: values.Status,
                        Comments: values.Comments,
                        studentData: this.props.multipleData
                    }
                    this.setState({ loading: true });

                    this.ajaxCall('POST', '/api/students/grademultipletest',
                        formObj, (data) => {//success
                            console.log('Graded!' + JSON.stringify(data));
                            this.props.updateEvent();
                            this.setState({ loading: false });
                        }, () => {//fail
                            this.openNotificationWithIcon('error', 'Failed To Add', 'Connection to server may have been lost!')
                            this.setState({ loading: false })
                            console.log('failed to register');
                        });
                }
                else {
                    var formObj = {
                        AttendedDate: values.AttendedDate.format("YYYY-MM-DD HH:mm:ss"),
                        CompletionDate: values.CompletionDate.format("YYYY-MM-DD HH:mm:ss"),
                        CompletionCriteriaId: values.Status,
                        Comments: values.Comments,
                        Id: this.props.updateFields.Id
                    }

                    this.setState({ loading: true });

                    this.ajaxCall('POST', '/api/students/gradetest',
                        formObj, (data) => {//success
                            console.log('Graded!' + JSON.stringify(data));
                            this.props.updateEvent();
                            this.setState({ loading: false });
                        }, () => {//fail
                            this.openNotificationWithIcon('error', 'Failed To Add', 'Connection to server may have been lost!')
                            this.setState({ loading: false })
                            console.log('failed to register');
                        });
                }

                this.props.form.setFieldsValue({
                    ['Status']: "",
                });


            }
        });
    }

    /**
     * Used for custom ajax calls
     * @param {any} type
     * @param {any} url
     * @param {any} data
     * @param {any} done
     * @param {any} fail
     */
    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    /**
    * Opend Notification window
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    /**
     * Render Functino
     */
    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 26 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 26 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };

        const dateFormat = 'MM-DD-YYYY';

        return (
            <div>
                {this.state.login ?
                    <Spin spinning={this.state.loading}>
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem {...formItemLayout} label="Attended Date" >
                                {getFieldDecorator('AttendedDate', {
                                    initialValue: this.formVariables.AttendedDate,
                                    rules: [{
                                        required: true, message: 'Please input the class name!',
                                    }],
                                })(<DatePicker format={dateFormat} />)}
                            </FormItem>
                            <FormItem
                                label="Completed Date"
                                {...formItemLayout}>
                                {getFieldDecorator('CompletionDate', {
                                    initialValue: this.formVariables.CompletionDate,
                                    rules: [{ required: true, message: 'Please select a system!' }],
                                })(
                                    <DatePicker format={dateFormat} />
                                )}
                            </FormItem>
                            <FormItem
                                label="Completion Status"
                                {...formItemLayout}>
                                {getFieldDecorator('Status', {
                                    initialValue: this.props.updateFields.CompletionCriteriaId,
                                    rules: [{ required: true, message: 'Please select a Type!' }],
                                })(
                                    <Select
                                        placeholder="Class Type">
                                        {this.state.statusData.map(d => <Option key={d.Id}>{d.AdditionalValues[0]}</Option>)}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Comments">
                                {getFieldDecorator('Comments', {
                                    initialValue: this.formVariables.Comments
                                })(<Input />)}
                            </FormItem>
                            {false && <FormItem {...tailFormItemLayout}>
                                <Button type="submit" htmlType="submit" size="large">Next</Button>
                            </FormItem>}
                            {true && <FormItem {...tailFormItemLayout}>
                                <button className="btn btn-default" type="submit" style={{ margin: 5 }} size="large">Submit</button>
                                <button type="submit" className="btn btn-default" onClick={() => { this.props.updateEvent(); }} >Cancel</button>
                            </FormItem>}
                        </Form>
                    </Spin>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }
}

const WrappedAddClassesForm = Form.create()(GradeStudent);

export default WrappedAddClassesForm;


// WEBPACK FOOTER //
// ./src/Admin/GradeStudent.js